import React, { useContext, useEffect } from 'react';

import Paper from '@material-ui/core/Paper';
import { RouteComponentProps } from '@reach/router';
import ReactMarkdown from 'react-markdown';

import { GlobalContext } from '../../../store';
import { IPagesStore } from '../../../store/pages/store';

import { Subheader } from '../Common/Subheader/Subheader';

interface IProps extends RouteComponentProps {
  pages: IPagesStore;
  clubId: number;
  slug: string;
}

export const Pages = (props: IProps) => {
  const { clubId, pages, slug } = props;

  const {
    adminClubs,
    actions: {
      adminEvents: { all: getAllAdminEvents },
      adminClubs: { get: getAdminClubs }
    }
  } = useContext(GlobalContext);

  useEffect(() => {
    getAllAdminEvents(clubId).catch();
    getAdminClubs(clubId);
  }, [clubId]);

  const club = adminClubs[clubId];

  const page = (pages[clubId] || []).find(p => p.id === Number(slug));

  const title = page ? page.name : 'Not Found';
  const content = page ? page.content : 'Page Under Construction';

  return (
    <div className="admin-club-home admin-layout">
      {club && (
        <div>
          <Subheader clubId={club.id} profileImage={club.profileImage} />
          <div className="admin-wrapper">
            <div className="events-section">
              <div className="shadowed-headline">
                <h2>{title}</h2>
              </div>
              <Paper elevation={1} className="page-content">
                <ReactMarkdown source={content} className="markdown" />
              </Paper>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
